import { render, staticRenderFns } from "./EditCompanyWiseTransactionFeeComponent.vue?vue&type=template&id=66bee38c&"
import script from "./EditCompanyWiseTransactionFeeComponent.vue?vue&type=script&lang=js&"
export * from "./EditCompanyWiseTransactionFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports